var map = {
	"./all-done.svg": "./src/assets/all-done.svg",
	"./failed.svg": "./src/assets/failed.svg",
	"./icons/check-mark.svg": "./src/assets/icons/check-mark.svg",
	"./icons/deposit.svg": "./src/assets/icons/deposit.svg",
	"./icons/egwi.svg": "./src/assets/icons/egwi.svg",
	"./icons/extraPayment.svg": "./src/assets/icons/extraPayment.svg",
	"./icons/inventory.svg": "./src/assets/icons/inventory.svg",
	"./icons/leaving.svg": "./src/assets/icons/leaving.svg",
	"./icons/picture.svg": "./src/assets/icons/picture.svg",
	"./icons/rent.svg": "./src/assets/icons/rent.svg",
	"./icons/staying.svg": "./src/assets/icons/staying.svg",
	"./icons/studentTax.svg": "./src/assets/icons/studentTax.svg",
	"./icons/undecided.svg": "./src/assets/icons/undecided.svg",
	"./kotkip.svg": "./src/assets/kotkip.svg",
	"./mollie.svg": "./src/assets/mollie.svg",
	"./success.svg": "./src/assets/success.svg",
	"./twikey.svg": "./src/assets/twikey.svg",
	"./upgrade-estate.svg": "./src/assets/upgrade-estate.svg",
	"./upkot-old-logo.svg": "./src/assets/upkot-old-logo.svg",
	"./upkot.svg": "./src/assets/upkot.svg",
	"./upliving.svg": "./src/assets/upliving.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*\\.svg$";